import React from 'react';
import { useSelector } from 'react-redux';

import { AppState } from '../../store';

import Steps from '../../components/application/Register/Steps';
import FormLoginSngpc from '../../components/application/Register/FormLoginSngpc';
import FormCompany from '../../components/application/Register/FormCompany';
import FormAccount from '../../components/application/Register/FormAccount';

import * as Styles from './RegisterStyles';

const Register: React.FC = () => {
  const { currentStep } = useSelector((state: AppState) => state.sngpc);

  return (
    <Styles.Container>
      <Steps currentStep={currentStep} />
      {currentStep === 1 && <FormLoginSngpc />}
      {currentStep === 2 && <FormCompany />}
      {currentStep === 3 && <FormAccount />}
    </Styles.Container>
  );
};

export default Register;
